import { AfterViewInit, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SelfAttendanceService } from '../../shared/services/self-attendance.service';
import { SelfAttendanceData } from '../../shared/model/self-attendance-data';
import { DtmService } from '../../services/dtm.service';
import { Dtm, getDtm } from '../../shared/enum/dtm';
import { SYDLEClientID } from '../../shared/constants/one-constants';
import { SessionStorageService } from "../../shared/services/session-storage.service";
import { environment } from 'src/environments/environment';
import { SelfAttendanceHeroData } from 'src/app/shared/model/hero-data';
import { LoadingService } from 'src/app/shared/services/loading.service';
import { CookieService } from 'ngx-cookie-service';
import { ECommerceService } from "../../services/e-commerce.service";

@Component({
    selector: "pme-self-attendance-success",
    templateUrl: './success.component.html',
    styleUrls: ['./success.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SelfAttendanceSuccessComponent implements OnInit, AfterViewInit, OnDestroy {
  selfAttendanceData: SelfAttendanceData;
  selfAttendanceHeroData: SelfAttendanceHeroData;

  classificationIdentifier: string;

  redirectURL: string;

  hideInvoiceBankBilletMessage: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public dtmService: DtmService,
    private selfAttendanceService: SelfAttendanceService,
    public sessionStorageService: SessionStorageService,
    private loading: LoadingService,
    private cookieService: CookieService,
    public ecommerceService: ECommerceService
  ) {
    if (!this.selfAttendanceService.getCurrentSelfAttendanceData()) {
      this.selfAttendanceService.getSelfAttendanceDataFromSessionStorage();
    }

    this.classificationIdentifier = this.sessionStorageService.getClassification(route);
    // Adobe Analytics - Padronizacao Setembro/2020

    this.selfAttendanceData = this.selfAttendanceService.getCurrentSelfAttendanceData();
    if (
      this.selfAttendanceData &&
      this.selfAttendanceData.businessId &&
      this.selfAttendanceData.userId
    ) {
      this.dtmService.userLoaded({
        businessId: this.selfAttendanceData.businessId,
        userId: this.selfAttendanceData.userId,
        cliendId: SYDLEClientID,
      });
    }


      this.dtmService.pageLoaded(Dtm.PagamentoReconhecidoUpgrade, true, getDtm(Dtm.PagamentoReconhecidoUpgrade, this.classificationIdentifier));


    this.redirectURL = this.getRedirectUrl();
  }
  ngAfterViewInit(): void {
    this.loading.finishTask();
  }

  ngOnInit() {
    let totalValue, couponAmount, amountRemaining, product;
    this.bindHeroInformation();
    if (this.selfAttendanceData.contract &&
      (this.selfAttendanceData.bankBilletData || this.selfAttendanceData.creditCardData || this.selfAttendanceData.pixData)) {

      totalValue = this.selfAttendanceData.bankBilletData ? this.selfAttendanceData.bankBilletData.totalValue : this.selfAttendanceData.creditCardData? this.selfAttendanceData.creditCardData.totalValue : this.selfAttendanceData.pixData ? this.selfAttendanceData.pixData.totalValue : 0;
      couponAmount = this.selfAttendanceData.bankBilletData ? this.selfAttendanceData.bankBilletData.discountedValue : this.selfAttendanceData.pixData ? this.selfAttendanceData.pixData.discountedValue : this.selfAttendanceData.creditCardData.discountedValue;
      amountRemaining = this.selfAttendanceData.contract.product.value ? this.selfAttendanceData.contract.product.value - totalValue : 0;
      product = this.selfAttendanceData.contract.product;

      if (product.classificationIdentifier === "plano-mensal") {
        this.cookieService.delete('subscriptionPlansType', '/'); // Limpa o cookie usado para encaminhar pra vitrine híbrida
        product.classificationIdentifier = "assinatura";
      }
      this.dtmService.productsLoaded([
        {
          identifier: this.selfAttendanceData.service === 'upgrade' ?
            sessionStorage.getItem('nextPlan') : this.selfAttendanceData.contract.product.identifier,
          classificationName: this.selfAttendanceData.contract.product.classificationName,
          quantity: '1',
          totalValue: totalValue,
          merchandising: product
        },
      ]);

      this.dtmService.checkoutSuccess({
        orderId: this.selfAttendanceData.contract.code, // OrderID OTC
        orderEventId: this.selfAttendanceData.creditCardData ? this.selfAttendanceData.creditCardData.invoiceId : this.selfAttendanceData.bankBilletData ? this.selfAttendanceData.bankBilletData.invoiceId : this.selfAttendanceData.pixData ? this.selfAttendanceData.pixData.invoiceId : "",
        totalPrice: this.selfAttendanceData.bankBilletData
          ? this.selfAttendanceData.bankBilletData.totalValue
          : this.selfAttendanceData.creditCardData
            ? this.selfAttendanceData.creditCardData.totalValue
            : this.selfAttendanceData.pixData
              ? this.selfAttendanceData.pixData.totalValue
              : '',
        pagamento: this.selfAttendanceData.contract.paymentMethod.identifier,
        amountPaid: this.selfAttendanceData.creditCardData ? this.selfAttendanceData.creditCardData.totalValue : '0.00',
        firstTime: this.selfAttendanceData.service === 'upgrade' ? false : true, // TODO - Colocar firstTime no retorno da venda por saldo insuficiente
        orderType: this.selfAttendanceData.contract.adobeAnalyticsData ? this.selfAttendanceData.contract.adobeAnalyticsData.purchaseType : null,
        amountRemaining: amountRemaining > 0 ? parseFloat(amountRemaining.toString()).toFixed(2) : '0.00',
        coupon: this.getConcatenatedDiscounts(), // TODO - preencher array appliedCoupons no retorno para upgrade e venda com saldo
        couponAmount: couponAmount, // TODO - preencher array appliedCoupons no retorno para upgrade e venda com saldo
        autoRecharge: this.selfAttendanceData.contract.provisioningParameters?.allowAutomaticRecharge,
        appliedCoupons: this.selfAttendanceData.contract.paymentMethod.identifier === 'BANK_BILLET' ?
          this.selfAttendanceData.bankBilletData.appliedCoupons : this.selfAttendanceData.contract.paymentMethod.identifier === 'PIX' ?
            this.selfAttendanceData.pixData.appliedCoupons : this.selfAttendanceData.creditCardData.appliedCoupons,
        installments: this.selfAttendanceData.contract.paymentMethod.identifier === 'CREDIT_CARD' ?
          this.selfAttendanceData.contract.paymentMethod.paymentConditionIdentifier : null,
        purchaseStatus: this.selfAttendanceData.contract.status,
        changeType:
          this.selfAttendanceData.service === 'upgrade'
            ? this.selfAttendanceData.service
            : null,
        packageChange: this.selfAttendanceData.service === 'upgrade' ? [sessionStorage.getItem('fromToUpgrade')] : null,
        amountTotal: this.selfAttendanceData.contract.product.value ? parseFloat(this.selfAttendanceData.contract.product.value.toString()).toFixed(2) : '0.00',
        bonusAmount: this.selfAttendanceData.bonusAmount,
        bonus: this.selfAttendanceData.bonus
      });
    } else if (this.selfAttendanceData.account) {
      if (this.selfAttendanceData.account.wallet && this.selfAttendanceData.account.wallet.automaticRecharge) {

        if (this.selfAttendanceData.account.wallet.automaticRecharge.product) {
          this.dtmService.productsLoaded([
            {
              identifier: this.selfAttendanceData.account.wallet.automaticRecharge.product.identifier,
              classificationName: this.selfAttendanceData.account.wallet.automaticRecharge.product.classificationName,  // 'Saúde do seu negócio',
              quantity: '1'
            },
          ]);
        }
      }

      this.dtmService.checkoutSuccess({
        orderId: this.selfAttendanceData.account.wallet.code, // OrderID OTC
        changeType:
          this.selfAttendanceData.service,
      });
    }

    let triggerType = "";
    if (this.selfAttendanceData.service === 'upgrade' || this.selfAttendanceData.service === 'expiredBankBillet' || this.selfAttendanceData.service === 'invoicingError' || this.selfAttendanceData.creditCardData && this.selfAttendanceData.creditCardData.chargedUser) {
      triggerType = 'Purchase';
    }


    this.dtmService.sendPageLoadEvent(triggerType);
  }

  /**
   * Função responsável por montar o hero de pagamento.
   */
  bindHeroInformation() {
    this.selfAttendanceHeroData = SelfAttendanceHeroData.fromPreset(this.selfAttendanceData.service, { classificationIdentifier: this.classificationIdentifier, selfAttendanceData: this.selfAttendanceData });
    this.selfAttendanceHeroData.dtmPageLoadedData.forEach(pageLoadedData => {
      if (pageLoadedData.pageName !== Dtm.UpgradeSucesso) {
        this.dtmService.pageLoaded(pageLoadedData.pageName, pageLoadedData.logged, pageLoadedData.mapped);
      }
    });
    this.selfAttendanceHeroData.dtmCustomLoadedData.forEach(data => {
      this.dtmService.customLoaded(data.events, data.checkout, data.userInfo, data.custom);
    });
  }

  ngOnDestroy(): void {
    this.selfAttendanceService.clearData();
    sessionStorage.removeItem('name');
    sessionStorage.removeItem('fromToUpgrade');
    sessionStorage.removeItem('email');
    sessionStorage.removeItem('originOfRequest');
    sessionStorage.removeItem('hash');
    sessionStorage.removeItem('redirectURL');
  }

  getConcatenatedDiscounts(): string {
    if (this.selfAttendanceData.contract.paymentMethod.identifier === 'CREDIT_CARD') {
      if (this.selfAttendanceData.creditCardData.appliedCoupons && this.selfAttendanceData.creditCardData.appliedCoupons.length) {
        return this.selfAttendanceData.creditCardData.appliedCoupons.map(coupon => coupon.identifier).join('|');
      }
    } else if (this.selfAttendanceData.contract.paymentMethod.identifier === 'BANK_BILLET') {
      if (this.selfAttendanceData.bankBilletData.appliedCoupons && this.selfAttendanceData.bankBilletData.appliedCoupons.length) {
        return this.selfAttendanceData.bankBilletData.appliedCoupons.map(coupon => coupon.identifier).join('|');
      }
    } else if (this.selfAttendanceData.contract.paymentMethod.identifier === 'PIX') {
      if (this.selfAttendanceData.pixData.appliedCoupons && this.selfAttendanceData.pixData.appliedCoupons.length) {
        return this.selfAttendanceData.pixData.appliedCoupons.map(coupon => coupon.identifier).join('|');
      }
    }
    return null;
  }

  getRedirectUrl() {
    let sessionStorageRedirectUrl = sessionStorage.getItem('redirectUrl') || sessionStorage.getItem('successRedirectUrl');
    let baseUrl = sessionStorageRedirectUrl ? sessionStorageRedirectUrl : this.selfAttendanceData.redirectURL;
    let url = baseUrl;
    if (!url || ['cancellation', 'paymentChange', 'CHANGE_AUTO_RECHARGE', 'ACTIVATE_AUTO_RECHARGE', 'AUTO_RECHARGE_PAYMENT_CHANGE','DEACTIVATE_AUTO_RECHARGE'].some(item => item === this.selfAttendanceData.service)) {
      url = environment.serasaHomePage;
    }

    if (this.classificationIdentifier === 'plano-mensal') {
      let fromSydle = '?fromSydle=true';
      if (url && url.indexOf('?') > -1) {
        fromSydle = '&fromSydle=true';
      }
      url += fromSydle;
    }
    return url;
  }

  onSuccessClick(ctaClicked: string) {
    document.location.href = "https://www.serasaempreendedor.com.br/v2/home";
  }

}
